export default __webpack_public_path__ + "static/media/room3.f19a1464.jpg";